<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-input prefix-icon="el-icon-search" placeholder="输入床位号查询" v-model="searchKeyword" style="width: 300px"></el-input>
      <el-select v-fixZoom v-model="sendType" placeholder="状态" style="width: 100px">
        <el-option v-for="item in typeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="getSearchData()">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="编号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="楼栋名"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="楼层号"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="床位"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="状态"
          min-width="70"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bedStatistics',
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      searchKeyword: '',
      typeArr: [{id: 0, name: '空闲'}, {id: 1, name: '已入住'}, {id: 1, name: '已预约'}],
      sendType: ''
    }
  },
  created () {
  },
  methods: {
    getSearchData () {},
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/bedStatistics.vue